/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo } from "react";

import { ToggleItemBox, BaselineTag } from "~/components";
import { baselineTagToShow, getFlatPlanEntities } from "~/utils";
import { PlanField } from "~/views/plans/PlanCreate/components/PlanCreateWizard/constants";
import { usePlanWizard } from "~/views/plans/PlanCreate/components/PlanCreateWizard/PlanProvider";
import { PlanActionTypeExtended, usePlan } from "../../PlanProvider";

export function ActionItem({
  entity,
  onMouseDown,
  editName,
}: {
  entity: PlanActionTypeExtended;
  onMouseDown: () => void;
  editName?: string | JSX.Element;
}) {
  const { planAction } = usePlan();
  const { planData } = usePlanWizard();

  const baselineTag = useMemo(
    () =>
      baselineTagToShow(
        entity,
        getFlatPlanEntities(
          planData?.[PlanField.PLAN_SETTINGS]?.planEntities ?? []
        )
      ),
    [entity, planData]
  );

  const editNameValue =
    typeof editName === "string" ? editName : editName?.props?.detail?.value;

  const shouldDisplayEditName =
    editNameValue && editNameValue.trim() !== entity.action?.name?.trim();

  return (
    <ToggleItemBox
      item={{
        id: entity.id ?? "",
        color: entity?.action?.color ?? "",
        name: (
          <div>
            <div>
              {shouldDisplayEditName
                ? entity.action?.name
                : editName || "No Action Name Provided"}
            </div>
            {shouldDisplayEditName && (
              <div
                style={{
                  opacity: 0.6,
                  fontSize: "0.85rem",
                }}
              >
                {editName}
              </div>
            )}
          </div>
        ),
        onMouseDown,
      }}
      tag={baselineTag ? <BaselineTag tag={baselineTag} /> : undefined}
      active={planAction?.listId === entity.listId}
    />
  );
}
